export const buildBookPath = ({ tenantId, branchId, serviceId } = {}) => {
  const params = new URLSearchParams();
  if (tenantId) params.set('tenantId', tenantId);
  if (branchId) params.set('branchId', branchId);
  if (serviceId) params.set('serviceId', serviceId);
  const query = params.toString();
  return query ? `/book?${query}` : '/book';
};

export const loginRedirectForBook = (bookPath) =>
  `/login?redirect=${encodeURIComponent(bookPath)}`;

export const isBookRedirect = (redirect) =>
  Boolean(redirect && redirect.startsWith('/book'));
